import type { ReactNode } from 'react';
import { Icon, type IconName } from '../Icon';
import styles from './FloatingButton.module.css';

export interface FloatingButtonProps {
  onClick: () => void;
  icon?: ReactNode | IconName;
  badge?: boolean | number;
  ariaLabel: string;
  position?: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';
  className?: string;
  iconOnly?: boolean;
}

export function FloatingButton({
  onClick,
  icon = 'chat',
  badge,
  ariaLabel,
  position = 'bottom-right',
  className = '',
  iconOnly = false,
}: FloatingButtonProps) {
  return (
    <button
      type="button"
      className={`${iconOnly ? styles.iconOnly : styles.fab} ${styles[position]} ${className}`}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {typeof icon === 'string' ? <Icon name={icon as IconName} size={iconOnly ? 48 : 24} /> : icon}
      {badge && !iconOnly && (
        <span
          className={styles.badge}
          aria-label={typeof badge === 'number' ? `${badge} unread` : 'Has updates'}
        >
          {typeof badge === 'number' && badge > 0 ? badge : null}
        </span>
      )}
    </button>
  );
}
